import * as React from 'react';

type orderConfirmProps = {
    orderConfirmed: boolean,
    onRequestOrder: boolean,
    translations: any
};

export const OrderConfirm = ({orderConfirmed, onRequestOrder, translations}: orderConfirmProps) => {
    return (
        <>
            <div className="order-confirmed" style={{display: orderConfirmed ? 'block' : 'none'}}>
                <span className="confirm-icon">✓</span>
                <h2>{translations.thank_you}!</h2>

                {onRequestOrder ? (<p>{translations.on_request_order_confirm_message}</p>):(<p>{translations.order_confirm_message}</p>)}

                <p className="mt32">
                    <a href="/" className="btn btn-primary btn-lg">{translations.go_home}</a>
                </p>
            </div>
        </>
    );
}
